var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactModal from 'react-modal';
import { useHistory } from 'react-router-dom';
export var ResourceModal = function (_a) {
    var children = _a.children, onClose = _a.onClose, isOpen = _a.isOpen, actionButtons = _a.actionButtons, props = __rest(_a, ["children", "onClose", "isOpen", "actionButtons"]);
    var history = useHistory();
    var handleClose = function () {
        history.replace('/');
        onClose();
    };
    return (React.createElement(ReactModal, __assign({ className: "EventModal__contentContainer", overlayClassName: "EventModal__overlay", ariaHideApp: false, onRequestClose: handleClose, isOpen: isOpen }, props),
        React.createElement("div", { className: "EventModal__box" },
            React.createElement("div", { className: "EventModal__closeContainer" },
                React.createElement("button", { className: 'EventModal__closeButton', onClick: handleClose },
                    React.createElement("span", { className: 'EventModal__closeButtonLabel' }, "Close"))),
            React.createElement("div", { className: "EventModal__layoutContainer" }, children),
            actionButtons &&
                React.createElement("div", { className: "EventModal__actionContainer" }, actionButtons))));
};
